import { Button, Dropdown, Icon, Input } from "semantic-ui-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import StatusFilter from "~/constants/Tour/StatusFilter";
import "../styles/TourIndexHeader.less";

@observer
class TourIndexHeader extends Component {
  render() {
    const {
      filterValue,
      statusFilterDropdownLabel,
      tempKeywordString,
      clearSearch,
      changeTempKeywordString,
      changeDropdown,
      hasSelectedFilters,
      groupCustomers,
      changeToursByCustomerOrCoCustomerId,
      customerOrCoCustomerId,
      t,
    } = this.props;

    const groupCustomerOptions = [{ key: 0, text: t("allTours"), value: "0" }];

    groupCustomers.forEach(customer => {
      const customerName = `${customer.firstName} ${customer.lastName}`;
      groupCustomerOptions.push({ key: customer.customerId, text: customerName, value: `${customer.customerId}` });
    });

    return (
      <div className="tour-index-header">
        <div className="tour-index-header-tagline">
          <span>{t("clientPanelMisc:searchBy")}</span>
        </div>

        <div id={hasSelectedFilters ? "has-clear-option" : "no-clear-option"} className="tour-index-header-grid-wrap">
          <div className="tour-index-header-controls dropdown-column">
            <Button.Group className="tour-index-filter-by">
              <Dropdown
                size="small"
                icon="caret down"
                className="button icon dropdown-filters"
                floating
                options={StatusFilter.map(statusFilter => {
                  return {
                    key: statusFilter.key,
                    value: statusFilter.value,
                    text: t(statusFilter.text),
                  };
                })}
                text={t(statusFilterDropdownLabel)}
                onChange={changeDropdown}
                value={filterValue}
              />
            </Button.Group>
            {groupCustomers.length > 0 ? (
              <Button.Group className="tour-index-filter-by">
                <Dropdown
                  size="small"
                  icon="caret down"
                  className="button icon dropdown-filters"
                  floating
                  scrolling
                  options={groupCustomerOptions}
                  text={t("clientPanelMisc:toursByAgent")}
                  onChange={changeToursByCustomerOrCoCustomerId}
                  value={customerOrCoCustomerId}
                />
              </Button.Group>
            ) : null}
            <div className="tour-index-header-search-container">
              <Input
                className="tour-index-header-search-btn"
                icon="search"
                placeholder={t("clientPanelMisc:searchTours")}
                value={tempKeywordString}
                onChange={changeTempKeywordString}
              />
              {hasSelectedFilters ? (
                <Button className="clear-filters-btn" icon onClick={clearSearch}>
                  <Icon name="remove circle" />
                  <span>{t("clear")}</span>
                </Button>
              ) : null}
            </div>
          </div>

          <div className="tour-index-header-h1">
            <h1>{t("myTours")}</h1>
          </div>
        </div>
      </div>
    );
  }
}

TourIndexHeader.propTypes = {
  statusFilterDropdownLabel: PropTypes.string.isRequired,
  hasSelectedFilters: PropTypes.bool.isRequired,
  tempKeywordString: PropTypes.string.isRequired,
  filterValue: PropTypes.string.isRequired,
  clearSearch: PropTypes.func.isRequired,
  changeTempKeywordString: PropTypes.func.isRequired,
  changeDropdown: PropTypes.func.isRequired,
  groupCustomers: PropTypes.array,
  changeToursByCustomerOrCoCustomerId: PropTypes.func,
  customerOrCoCustomerId: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourIndexHeader);
